export default {
    brush: {
        title: 'Spazzola',
        brushHardness: 'Durezza del pennello',
        brushSize: 'Dimensione del pennello',
        brushColor: 'Colore del pennello',
    },
};
